{
  "version": 1,
  "asset_id": "dd478e05-de41-468d-965d-7e91e5a4d9f7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/dd478e05-de41-468d-965d-7e91e5a4d9f7/gastric-bypass-es-v2-1536.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/dd478e05-de41-468d-965d-7e91e5a4d9f7/gastric-bypass-es-v2-1536.webp",
  "original_filename": "gastric-bypass-es-v2-1536.webp",
  "size": 106440,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:00:41Z"
}
